import Vue from 'vue';
import GetSequenceNumberListRequestModel from '../../../generated/types/model/request/GetSequenceNumberListRequestModel';

export default class GetSequenceNumberListRequestViewModel extends GetSequenceNumberListRequestModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}

  protected transformFromQuery(queries: Record<string, string>): void {
    super.transformFromQuery(queries);
    Vue.set(this.dto, 'levels', queries.levels);
  }
}
